export default "__VITE_ASSET__28f2afd5__"